'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('./Account.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Account = function (props) {
    var title = props.title, subtitle = props.subtitle, imgSrc = props.imgSrc, onBtnClick = props.onBtnClick, NextLink = props.NextLink;
    return (React__default['default'].createElement("div", { className: 'account-box' },
        React__default['default'].createElement("div", { className: 'account-box_image' },
            React__default['default'].createElement("img", { src: imgSrc, alt: "Lifepal Account", width: "200px", height: "200px" })),
        React__default['default'].createElement("div", { className: 'account-box_title' }, title),
        React__default['default'].createElement("div", { className: 'account-box_subtitle' }, subtitle),
        NextLink ?
            React__default['default'].createElement(React__default['default'].Fragment, null,
                React__default['default'].createElement(NextLink, { href: "/account/register" },
                    React__default['default'].createElement("a", { className: 'account-box_registerBtn', onClick: function () { return onBtnClick(); } }, "Daftar Akun")),
                React__default['default'].createElement(NextLink, { href: "/account/login" },
                    React__default['default'].createElement("a", { className: 'account-box_loginBtn', onClick: function () { return onBtnClick(); } }, "Masuk"))) :
            React__default['default'].createElement(React__default['default'].Fragment, null,
                React__default['default'].createElement("a", { className: 'account-box_registerBtn', href: "/account/register", onClick: function () { return onBtnClick(); } }, "Daftar Akun"),
                React__default['default'].createElement("a", { className: 'account-box_loginBtn', href: "/account/login", onClick: function () { return onBtnClick(); } }, "Masuk"))));
};

exports.Account = Account;
//# sourceMappingURL=Account.js.map
